import ExcelJS from 'exceljs';
import { getFloatCMV, getFullValueCMV, getMediumPriceCMV } from './cmv/convertQtd';

export async function exportFileHistory(items, filename) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Relatório');
  const days = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));

  worksheet.mergeCells('A1:E1');
  worksheet.getCell('A1').value = 'DIAS';
  worksheet.getCell('A2').value = 'NOME';
  worksheet.getCell('B2').value = 'UNIDADE';
  worksheet.getCell('C2').value = 'VALOR MÉDIO UNITÁRIO';
  worksheet.getCell('D2').value = 'VOLUME TOTAL';
  worksheet.getCell('E2').value = 'VALOR TOTAL';

  worksheet.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };
  worksheet.getCell('B1').alignment = { horizontal: 'center', vertical: 'middle' };
  worksheet.getCell('A2').alignment = { horizontal: 'center', vertical: 'middle' };
  worksheet.getCell('B2').alignment = { horizontal: 'center', vertical: 'middle' };
  worksheet.getCell('C2').alignment = { horizontal: 'center', vertical: 'middle' };
  worksheet.getCell('D2').alignment = { horizontal: 'center', vertical: 'middle' };
  worksheet.getCell('E2').alignment = { horizontal: 'center', vertical: 'middle' };

  let colIndex = 6;

  days.forEach(day => {
    worksheet.mergeCells(1, colIndex, 1, colIndex + 1);
    worksheet.getCell(1, colIndex).value = day;
    worksheet.getCell(2, colIndex).value = 'Entrada';
    worksheet.getCell(2, colIndex + 1).value = 'Valor Médio';
    // worksheet.getCell(2, colIndex + 1).value = 'Saída Man.';
    // worksheet.getCell(2, colIndex + 2).value = 'Saída Aut.';

    worksheet.getCell(1, colIndex).alignment = { horizontal: 'center', vertical: 'middle' };
    worksheet.getCell(2, colIndex).alignment = { horizontal: 'center', vertical: 'middle' };
    worksheet.getCell(2, colIndex + 1).alignment = { horizontal: 'center', vertical: 'middle' };

    colIndex += 2;
  });

  items.forEach((item, rowIdx) => {
    const excelRow = rowIdx + 3;

    worksheet.getCell(excelRow, 1).value = item.name;
    worksheet.getCell(excelRow, 2).value = item.unit;
    let totalVolume = 0;

    colIndex = 6;

    days.forEach(day => {
      const qtd = getFloatCMV(item?.days?.[day]?.qtd);
      const price = item?.days?.[day]?.price ?? 0;

      worksheet.getCell(excelRow, colIndex).value = qtd;
      worksheet.getCell(excelRow, colIndex + 1).value = getFullValueCMV(price, item.unit);
      worksheet.getCell(excelRow, colIndex + 1).numFmt = '"R$"#,##0.00';

      totalVolume += qtd;

      colIndex += 2;
    });


    const avgPrice = getMediumPriceCMV(item.priceTotal, totalVolume, item.unit)
    worksheet.getCell(excelRow, 3).value = avgPrice / 100; // medio unit
    worksheet.getCell(excelRow, 3).numFmt = '"R$"#,##0.00';
    worksheet.getCell(excelRow, 4).value = getFloatCMV(totalVolume); //volume total
    worksheet.getCell(excelRow, 5).value = getFullValueCMV(item.priceTotal, item.unit)// valor total
    worksheet.getCell(excelRow, 5).numFmt = '"R$"#,##0.00';
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
